import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../BitsStyles/ExpertiseHome.css';

const services = [
  {
    title: 'Mobile App Development',
    description: 'We build intuitive and high-performing mobile apps for Android and iOS platforms using React Native and Flutter.',
    link: '/service-bits',
    icon: 'bi-phone',
    accent: '#0066cc',
    gradient: 'linear-gradient(135deg, #e8f4ff, #b3d9ff)',
    tags: ['Android', 'iOS', 'Flutter', 'React Native'],
  },
  {
    title: 'Billing Solutions',
    description: 'We provide powerful billing engine solutions for your products with secure, automated payment workflows.',
    link: '/billing',
    icon: 'bi-receipt-cutoff',
    accent: '#0052a3',
    gradient: 'linear-gradient(135deg, #f0f0ff, #c8d8ff)',
    tags: ['Invoicing', 'Payments', 'Analytics', 'Tax'],
  },
  {
    title: 'Enterprise & Web Applications',
    description: 'Robust and scalable solutions for enterprise-level web applications with modern architecture.',
    link: '/service-bits',
    icon: 'bi-display',
    accent: '#003d7a',
    gradient: 'linear-gradient(135deg, #e8fff8, #b3ffd9)',
    tags: ['React', 'Node.js', 'MySQL', 'Cloud'],
  },
];

const Expertise = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('.exp-home-card').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="exp-home-section">
      <h2 className="exp-home-heading">Our Services</h2>
      <div className="exp-home-grid">
        {services.map((svc, index) => (
          <Link to={svc.link} className="exp-home-card" key={index}>
            <div className="exp-home-card-top" style={{ background: svc.gradient }}>
              <div className="exp-home-icon" style={{ color: svc.accent }}>
                <i className={`bi ${svc.icon}`}></i>
              </div>
              <div className="exp-home-tags">
                {svc.tags.map((tag, ti) => (
                  <span className="exp-home-tag" key={ti} style={{ color: svc.accent, borderColor: svc.accent + '40', background: svc.accent + '12' }}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="exp-home-card-body">
              <h2 className="exp-home-card-title">{svc.title}</h2>
              <p className="exp-home-card-desc">{svc.description}</p>
              <span className="exp-home-cta">
                Learn more <i className="bi bi-arrow-right"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Expertise;
